import React from 'react'

import './Card.css'

const Card = ({ children, className = '', ...others }) => {
  return (
    <div className={'card ' + className} {...others}>
      {children}
    </div>
  )
}

export default Card
